export default __webpack_public_path__ + "static/media/blog-01.168ec8bc.jpg";